import { useTranslation } from 'react-i18next';
import { MdLogout } from 'react-icons/md';
import { useRecoilValue } from 'recoil';
import { useMsal } from '@azure/msal-react';

import { useNavigate } from 'hooks';
import { isAdminState, isTQAdminState } from 'store';
import { MenuOption } from 'types';

export const useAppBarMenuOptions = (): MenuOption[] => {
  const { t } = useTranslation('app_bar');
  const isAdmin = useRecoilValue(isAdminState);
  const isTQAdmin = useRecoilValue(isTQAdminState);
  const { instance } = useMsal();
  const {
    navigateToManageTeam,
    navigateToManageAdminTeam,
    navigateToB2CChangePassword,
    navigateToTrafficMonitor,
    navigateToManageConsultees,
  } = useNavigate();

  const manageTeam = {
    label: t('manage_team', 'Manage team'),
    onClick: navigateToManageTeam,
  };

  const changePassword = {
    label: t('change_password', 'Change password'),
    onClick: navigateToB2CChangePassword,
  };

  const logOut = {
    label: t('log_out', 'Log out'),
    onClick: async () => {
      await instance.logout({
        postLogoutRedirectUri: '/',
      });
    },
    icon: MdLogout,
    iconRight: true,
  };

  const trafficMonitor = {
    label: t('traffic_monitor', 'Traffic monitor'),
    onClick: navigateToTrafficMonitor,
  };

  const manageTQUsers = {
    label: t('manage_tq_users', 'Manage TQ users'),
    onClick: navigateToManageAdminTeam,
  };

  const manageConsultees = {
    label: t('manage_consultees', 'Manage consultees'),
    onClick: navigateToManageConsultees,
  };

  const menuOptions: MenuOption[] = [changePassword, logOut];

  if (isTQAdmin) menuOptions.splice(0, 0, manageTQUsers, manageConsultees, trafficMonitor);
  if (isAdmin) menuOptions.splice(0, 0, manageTeam);

  return menuOptions;
};
